import React from 'react';
import PublicLayout from '@/components/PublicLayout';
import SEO from '@/components/SEO';

const TermsPage = () => (
  <PublicLayout>
    <SEO title="Terms of Use" description="EdAssist terms and conditions. Read the rules and guidelines for using our education job portal and services." path="/terms" />
    <div className="max-w-4xl mx-auto px-4 py-16" data-testid="terms-page">
      <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>Terms and Conditions</h1>
      <p className="text-slate-500 mb-10">Effective Date: 1st June 2025 | Last Updated: 30th May 2025</p>

      <div className="prose prose-slate max-w-none">
        <p>Welcome to EdAssist (the "Platform"), a job board service operated by HRassistance India Consultancy LLP, based in Pune, India. By accessing or using EdAssist, you agree to be bound by the following Terms and Conditions. Please read them carefully.</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By accessing or using EdAssist, you agree to comply with and be bound by these Terms and Conditions, as well as our Privacy Policy. If you do not agree, you may not access or use the Platform.</p>

        <h2>2. Services Provided</h2>
        <p>EdAssist offers a platform to:</p>
        <ul>
          <li><strong>Job Seekers:</strong> Search and apply for jobs in the education sector and training programs.</li>
          <li><strong>Employers/Recruiters:</strong> Post job listings, search candidate profiles, and manage recruitment activities.</li>
        </ul>
        <p>EdAssist is not responsible for the quality, safety, or legality of jobs or resumes posted.</p>

        <h2>3. User Eligibility</h2>
        <ul>
          <li>Be at least 18 years old and legally capable of entering into a binding contract under Indian law to use this Platform.</li>
          <li>Provide accurate and complete information when registering.</li>
          <li>Use the platform lawfully and in accordance with these terms.</li>
        </ul>

        <h2>4. User Obligations</h2>
        <p>Users must not:</p>
        <ul>
          <li>Post false or misleading information.</li>
          <li>Upload offensive, harmful, or illegal content.</li>
          <li>Impersonate any person or entity.</li>
          <li>Violate any applicable laws or third-party rights.</li>
        </ul>
        <p>Additionally:</p>
        <ul>
          <li>Users are responsible for maintaining the confidentiality of their login credentials.</li>
          <li>Any unauthorized use of your account should be reported immediately.</li>
          <li>We reserve the right to suspend or terminate accounts if users violate these terms.</li>
        </ul>

        <h2>5. Job Listings & Applications</h2>
        <ul>
          <li>Job postings must be accurate and comply with local employment regulations.</li>
          <li>EdAssist does not guarantee job placement and is not responsible for employer practices.</li>
          <li>Users applying for jobs must ensure their information is truthful and up to date.</li>
        </ul>

        <h2>6. Acceptable Use Policy</h2>
        <p>Users must not:</p>
        <ul>
          <li>Post misleading, fraudulent, or offensive content.</li>
          <li>Use the platform for spam, harassment, or illegal activities.</li>
          <li>Attempt to breach security, reverse-engineer, or exploit the system.</li>
        </ul>

        <h2>7. Account Security</h2>
        <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized access or security breach.</p>

        <h2>8. Content Ownership</h2>
        <p>All content you post remains your intellectual property. By posting on EdAssist, you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, and display such content solely for the purpose of operating and promoting the Platform.</p>

        <h2>9. Payment and Refunds</h2>
        <p>Employers may be charged for premium listings or additional services. All payments are final and non-refundable unless stated otherwise.</p>

        <h2>10. Third-Party Links</h2>
        <p>The Platform may contain links to third-party websites. EdAssist does not endorse or take responsibility for the content or policies of these external sites.</p>

        <h2>11. Limitation of Liability</h2>
        <p>EdAssist shall not be liable for any indirect, incidental, special, or consequential damages arising out of your use of or inability to use the Platform.</p>

        <h2>12. Termination</h2>
        <p>We reserve the right to suspend or terminate your access to the Platform at our discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users.</p>

        <h2>13. Governing Law and Jurisdiction</h2>
        <p>These terms are governed by Indian laws, and any disputes will be resolved through arbitration in Pune, Maharashtra.</p>

        <h2>14. Modifications</h2>
        <p>We reserve the right to modify these Terms at any time. Continued use of the Platform constitutes acceptance of the revised Terms.</p>

        <h2>15. Contact Us</h2>
        <p>If you have any questions about these Terms, you may contact us at:</p>
        <p><strong>EdAssist</strong><br />(HRassistance India Consultancy LLP)<br />Email: <a href="mailto:info@edassist.co.in" className="text-indigo-600">info@edassist.co.in</a><br />Address: 205A, Town Square, Viman Nagar, Pune-411014, India</p>
      </div>
    </div>
  </PublicLayout>
);

export default TermsPage;
